import React, {
  useState, useMemo,
} from 'react';
import { usePaginatedQuery } from '@playbookux/playbook-web-core';
import PropTypes from 'prop-types';
import useDebounce from '../../../../../../core/hooks/use-debounce';
import {
  Dropdown,
} from '../../../styles';

import {
  GET_PROJECTS_BY_COMPANY,
  ORDER_PROJECTS_BY,
  DEBOUNCE_TIME,
} from '../../graphql';

const DropdownComponent = (props) => {
  const {
    company,
    selectedProject,
    setProject,
    setFieldValue,
  } = props;
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebounce(() => search, DEBOUNCE_TIME, [search]);

  const projectAttributes = {
    skip: !company,
    variables: {
      limit: 50,
      offset: 0,
      companyId: company,
      name: debouncedSearch || '',
      order: ORDER_PROJECTS_BY,
    },
  };

  const {
    data: projectData = [],
    loading,
  } = usePaginatedQuery(GET_PROJECTS_BY_COMPANY, projectAttributes, { dataField: 'projects' });

  const projectList = useMemo(() => {
    let newOptions = [];
    if (projectData && projectData.projects) {
      newOptions = projectData.projects.map((project) => ({
        key: project.id,
        value: project.id,
        text: project.name,
      }));
    }
    return newOptions;
  }, [projectData]);

  const handleSearchChange = (e, { searchQuery }) => {
    setSearch(searchQuery.trim());
  };

  const handleChangeProject = (value) => {
    if (value === '') {
      setSearch('');
    }
    setFieldValue('project', value, true);
    setProject(value);
  };

  return (
    <Dropdown
      loading={loading}
      disabled={loading}
      options={projectList}
      clearable
      search
      selection
      onSearchChange={handleSearchChange}
      onChange={(_, { value }) => handleChangeProject(value)}
      value={selectedProject}
    />
  );
};

DropdownComponent.propTypes = {
  company: PropTypes.string.isRequired,
  selectedProject: PropTypes.string.isRequired,
  setProject: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default DropdownComponent;
